import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomText from '../../common/subcomponents/Typography/CustomText';

const PrimaryActionTitleBodySection = ({ actionTitle, actionBody, theme }) => (
  <>
    <Box sx={{ paddingRight: '0px', position: 'relative' }}>
      {actionTitle && (
        <CustomText
          font="Source Sans Pro"
          color={theme.palette.gray?.[800] || '#3A3A3A'}
          fontSize={{ xs: '28px', sm: '40px' }}
          fontWeight="500"
          lineHeight="48px"
          // listSpacing="0px"
        >
          {actionTitle}
        </CustomText>
      )}
    </Box>
    <Box
      sx={{
        paddingTop: theme.spacing(2),
        position: 'relative',
      }}
    >
      {actionBody && (
        <Typography
          sx={{
            font: 'Source Sans 3',
            color: theme.palette.gray?.[600] || '#6B6B6B',
            fontSize: '17px',
            fontWeight: '400',
            lineHeight: '24px',
            listSpacing: '4px',
            justifyItems: 'end',
            textAlign: 'left',
          }}
        >
          {actionBody}
        </Typography>
      )}
    </Box>
  </>
);

export default PrimaryActionTitleBodySection;
